// removed by extract-text-webpack-plugin
module.exports = {"container":"_1AsOCga1LWl6cR2n_r05SJ"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Createorganization/Layout/styles.css
// module id = 3030
// module chunks = 0